import * as Yup from "yup";

const initialValues = {
  old_plan: null,
  new_plan: null,
  after_days: 0,
};

const subscriptionMigrationSchema = Yup.object().shape({
  old_plan: Yup.object().shape({
    id: Yup.number().required(),
    label: Yup.string().required(),
  }).required("O campo plano antigo é obrigatório!"),
  new_plan: Yup.object().shape({
    id: Yup.number().required(),
    label: Yup.string().required(),
  }).required("O campo plano novo é obrigatório!"),
  old_price: Yup.string().optional(),
  new_price: Yup.string().optional(),
  after_days: Yup.number().required("O campo de dias para a migração é obrigatório!"),
});

export { initialValues, subscriptionMigrationSchema };
